import { useCallback, useRef } from 'react';
import { useRouter } from '@atlassian/react-resource-router';
import { useBacklogSelector, useBacklogActionCreator } from '../../state';
import { closeDetailView, openDetailView } from '../../state/actions/detail-view';
import type { DetailViewState } from '../../state/reducers/ui/detail-view/types';
import { getDetailView } from '../../state/selectors/app';
import { makeCardKeyFromCardId } from '../../state/selectors/cards';

export const useCloseIssueViewOnBulkOpsEdit = () => {
	const handleCloseIssueView = useBacklogActionCreator(closeDetailView);
	const handleOpenIssueView = useBacklogActionCreator(openDetailView);
	const openIssue = useBacklogSelector(getDetailView);
	const getIssueKey = useBacklogSelector(makeCardKeyFromCardId);
	const lastDetailViewOpen = useRef<DetailViewState>(null);
	const [routerState, { replaceTo }] = useRouter();

	const closeIssueView = useCallback(() => {
		if (!lastDetailViewOpen.current) {
			lastDetailViewOpen.current = openIssue;
			handleCloseIssueView();
		}
	}, [handleCloseIssueView, openIssue]);

	const openIssueView = useCallback(() => {
		if (lastDetailViewOpen.current) {
			const { cardId, externalAction } = lastDetailViewOpen.current;
			const selectedIssue = getIssueKey(cardId);

			lastDetailViewOpen.current = null;

			handleOpenIssueView(cardId, externalAction);
			replaceTo(routerState.route, {
				params: routerState.match.params,
				query: { ...routerState.query, selectedIssue },
			});
		}
	}, [
		getIssueKey,
		handleOpenIssueView,
		replaceTo,
		routerState.match.params,
		routerState.query,
		routerState.route,
	]);

	return { closeIssueView, openIssueView };
};
